(function ($, window) {
    'use strict';

    $(function () {
        const $body = $('body');
        const $header = $('.js-sticky-header');
        const activeClass = 'is-sticky';
        const interval = 250;

        let visibleHeight = 400;
        let hasScrolled = false;
        let lastScroll = 0;

        $(window).on('scroll', function () {
            hasScrolled = true;
        });

        setInterval(function () {
            if (hasScrolled) {
                handleScroll();
                hasScrolled = false;
            }
        }, interval);

        function handleScroll() {
            const currentScrollTop = ($(window).scrollTop() || $body.scrollTop());
            const isActive = $header.hasClass(activeClass);

            if (currentScrollTop > visibleHeight && currentScrollTop < lastScroll) {
                if (!isActive) {
                    $body.addClass('sticky-header-active');
                    $header.addClass(activeClass).attr('aria-hidden', false);
                }
            } else {
                if (isActive) {
                    $body.removeClass('sticky-header-active');
                    $header.removeClass(activeClass).attr('aria-hidden', true);
                }
            }

            lastScroll = currentScrollTop;
        }

        $(window).trigger('scroll');
    });
})(jQuery, window);